import {
  faCheckCircle,
  faCircleDashed
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cva, type VariantProps } from "class-variance-authority";

const stampcardCollectBadgeStyles = cva(
  "flex w-24 items-center justify-center gap-1 rounded-xl bg-kiosk-accent-secondary",
  {
    variants: {
      size: {
        sm: "h-10",
        md: "h-14"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
);

type StampcardCollectBadgeProps = VariantProps<
  typeof stampcardCollectBadgeStyles
> & {
  count: number;
};

export const StampcardCollectBadge = ({
  count,
  size
}: StampcardCollectBadgeProps) => {
  return (
    <div className={stampcardCollectBadgeStyles({ size })}>
      <StampcardCollectBadgeIcon enabled={count > 0} />
      <StampcardCollectBadgeIcon enabled={count > 1} />
      <StampcardCollectBadgeIcon enabled={count > 2} />
    </div>
  );
};

type StampcardCollectBadgeIconProps = {
  enabled: boolean;
};

const StampcardCollectBadgeIcon = ({
  enabled
}: StampcardCollectBadgeIconProps) => {
  return (
    <FontAwesomeIcon
      className="text-kiosk-text-primary"
      size="lg"
      icon={enabled ? faCheckCircle : faCircleDashed}
    />
  );
};
